export function keepQueryParameter(urlString: string, parameterToKeep: string) {
   const uri = new URL(urlString);

   // We must create a copy of the searchParam's keys (using the spread operator), because .keys returns an iterator and we are modifying the collection. 
   // If we do not make a copy of the keys, then the for..of loop stops too early
   for (const key of [...uri.searchParams.keys()]) {
       if (key == parameterToKeep) { continue; }
       uri.searchParams.delete(key);
   }
    

   return uri.toString();
}